/**
 * 跨平台图片下载函数
 * @param {string} url - 图片URL
 * @param {string} fileName - 下载文件名(不带扩展名)
 * @returns {Promise<void>}
 */
export function downloadImageCrossPlatform(url, fileName = 'image') {
    return new Promise((resolve, reject) => {
        // 1. 创建Image对象并处理跨域
        const img = new Image();
        img.crossOrigin = 'Anonymous';

        // 添加时间戳避免缓存问题
        const timestampedUrl = url + (url.includes('?') ? '&' : '?') + 't=' + Date.now();
        img.src = timestampedUrl;

        img.onload = () => {
            try {
                // 2. 创建Canvas处理图片
                const canvas = document.createElement('canvas');
                canvas.width = img.naturalWidth;
                canvas.height = img.naturalHeight;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);

                // 3. 转换为Blob
                canvas.toBlob((blob) => {
                    if (!blob) {
                        reject(new Error('图片转换失败'));
                        return;
                    }

                    // 4. 创建下载链接
                    const blobUrl = URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = blobUrl;

                    // 根据平台特性设置文件名
                    const ext = getExtensionFromMime(blob.type);
                    link.download = `${fileName}${ext}`;

                    // 5. 触发下载
                    document.body.appendChild(link);
                    link.click();

                    // 6. 清理资源
                    setTimeout(() => {
                        document.body.removeChild(link);
                        URL.revokeObjectURL(blobUrl);
                        resolve();
                    }, 100);
                }, 'image/jpeg', 0.92); // 默认使用JPEG格式
            } catch (error) {
                reject(error);
            }
        };

        img.onerror = () => {
            reject(new Error('图片加载失败'));
        };
    });
}

/**
 * 根据MIME类型获取文件扩展名
 * @param {string} mimeType 
 * @returns {string}
 */
function getExtensionFromMime(mimeType) {
    const mimeMap = {
        'image/jpeg': '.jpg',
        'image/png': '.png',
        'image/gif': '.gif',
        'image/webp': '.webp'
    };
    return mimeMap[mimeType] || '.jpg';
}

// 导出检测平台函数
export function isIOS() {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

export function isAndroid() {
    return /Android/i.test(navigator.userAgent);
}

